<template>
  <b-row class="m-lg-4 m-2">
    <b-table
      class="mb-0 table-outline"
      id="site-sumary-table"
      responsive="sm"
      stacked="md"
      hover
      :items="summaryItems"
      :fields="summaryFields"
      :per-page="itemsPerPage"
      :busy="loading"
      head-variant="light">
      <div slot="info" slot-scope="item" class="my-2">

        <span class="site-title">
          <font-awesome-icon transform="grow-2" class="mx-2" v-tooltip.bottom="item.value.connection.popover" :class="item.value.connection.class" icon="plug" />
          {{item.value.name}}
        </span>
      </div>
      <b-card slot="weather" slot-scope="item" no-body :class="item.value.class" class="site-card">
        <b-card-body id="weather-card-body">
          <font-awesome-icon :icon="item.value.icon" style="font-size: 51px;" v-tooltip.bottom="item.value.popover" />
        </b-card-body>
      </b-card>
      <b-card slot="tracker" slot-scope="item" :class="item.value.class" class="site-card" v-tooltip.bottom="item.value.popover">
        <h6 class="mb-0">{{item.value.description}}</h6>
      </b-card>
      <b-card slot="armature" slot-scope="item" :class="item.value.class" class="site-card" v-tooltip.bottom="item.value.popover">
        <h6 class="mb-0">{{item.value.description}}</h6>
      </b-card>
      <b-card slot="forecast" slot-scope="item" :no-body="item.value.loading" :class=item.value.class class="site-card" v-tooltip.bottom="item.value.popover">
        <b-card-body v-if="item.value.loading" id="forecast-card-body">
          <font-awesome-icon :icon="item.value.loadingIcon" style="font-size: 51px;"  />
        </b-card-body>
        <h6 v-else class="mb-0">{{item.value.description}}</h6>
      </b-card>
      <div slot="gcuDetails" slot-scope="item">
        <font-awesome-icon :icon="item.value.icon" id="dropdown-icon" @click.stop="toggleDetails(item.index)" class="mx-auto" style="color: gray;"/>
      </div>
      <template slot="row-details" slot-scope="row">
        <gcu-summary :tableItems="row.item.gcus" :site="row.item.info.name"></gcu-summary>
      </template>
      <div slot="table-busy" class="text-center my-2">
        <msi-spinner class="align-middle"></msi-spinner>
      </div>
    </b-table>

    <!-- <img style="margin: 50px auto;" v-show="showLoader" src="img/msi_spinner.gif" height="50" width="50"> -->
  </b-row>
</template>

<script>
import _ from 'lodash';
import GcuSummary from './widgets/GCUSummary';
import Site from '../modules/Site';
import MsiSpinner from './MsiSpinner.vue'

// needed a way to maintain the dropdown state between updates of the summaryItems computed variable
const cachedDetailsStatus = [];

const setCachedDetailsStatus = (sites) => {
  sites.forEach((site) => {
    const index = cachedDetailsStatus.findIndex(a => a.name === site.name);
    if (index === -1) {
      cachedDetailsStatus.push({
        name: site.name,
        status: false,
      });
    }
  });
};

const updateCachedDetailsStatus = (siteName) => {
  const index = cachedDetailsStatus.findIndex(a => a.name === siteName);
  if (index !== -1) {
    cachedDetailsStatus[index].status = !cachedDetailsStatus[index].status;
  }
};

export default {
  name: 'SiteSummary',
  data() {
    return {
      itemsPerPage: 100,
      summaryFields: {
        info: { label: 'Site' },
        weather: { label: 'Current Weather' },
        tracker: { label: 'Tracker Status' },
        armature: { label: 'Armature Status' },
        forecast: { label: '5 Day Wind Forecast' },
        gcuDetails: { label: 'Details' }
      }
    };
  },
  computed: {
    summaryItems() {
      const { sites } = this.$store.state.savanna.sites;
      const { gcus, gcuStatus } = this.$store.state.savanna.gcus;
      const trackers = this.$store.getters['savanna/trackers/getTrackerStatus']();
      setCachedDetailsStatus(sites);

      const outputBuffer = [];
      sites.forEach((site) => {
        const siteGCUs = gcus.filter(a => a.site_id === site.id && a.count > 0);
        // If there are no GCUs the site will not be displayed (should only be useful internally)
        if (siteGCUs.length !== 0) {
          const userSite = new Site(site);
          userSite.setGCUs(siteGCUs, trackers, gcuStatus);
          if (userSite.gcus.length !== 0) {
            userSite.setStatus();
            userSite.setWeather(site.weather);
            userSite.setForecast(site.forecast);
            userSite.setComponentInfo('armature');
            userSite.setComponentInfo('tracker');
            userSite._showDetails = cachedDetailsStatus.find(a => a.name === site.name).status;
            userSite.gcuDetails = {
              icon: userSite._showDetails ? 'chevron-up' : 'chevron-down'
            };

            outputBuffer.push(userSite);
          }
        }
      });
      const outputArray = _.sortBy(outputBuffer, ['info.name']);

      return outputArray;
    },
    loading() {
      return this.summaryItems.length === 0;
    }
  },
  methods: {
    toggleDetails(index) {
      this.summaryItems[index]._showDetails = !this.summaryItems[index]._showDetails;
      this.summaryItems[index].gcuDetails.icon = this.summaryItems[index]._showDetails ? 'chevron-up' : 'chevron-down';
      updateCachedDetailsStatus(this.summaryItems[index].info.name);
    }
  },
  components: {
    GcuSummary,
    MsiSpinner
  }
};
</script>

<style>
#weather-card-body, #forecast-card-body {
  padding: 5px 0px 5px 0px
}

#dropdown-icon {
  cursor: pointer;
  font-size: 1.5em;
  display: block;
}

#site-sumary-table {
  width:100%;
  background-color:#FFF;
  margin-bottom: 0;
}

.site-card {
  margin-bottom: 0;
  text-align: center;
  color: white;
}

.site-title {
  font-size: 1.0rem;
}
</style>
